import { captureRecoveryLanding } from "./lib/recoveryLanding";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Read the recovery marker off the URL before anything can clear it.
//
// supabase-js (imported transitively by App) consumes the fragment and strips
// it as part of detectSessionInUrl. That work is ASYNC — the createClient call
// only queues it — so this synchronous statement runs first even though the
// import above it has already been evaluated. Keep it synchronous and keep it
// here, ahead of render. See src/lib/recoveryLanding.ts for what breaks
// otherwise.
captureRecoveryLanding();

createRoot(document.getElementById("root")!).render(<App />);
